import { Avatar } from "@mui/material";
import { Box, styled } from "@mui/system";
import { FC } from "react";
import { H4, Paragraph } from "../Typography";

const ReplayMassageBox = styled(Box)(() => ({
  display: "flex",
  marginBottom: "30px",
}));

const Message = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "1rem",
  borderRadius: "10px",
  position: "relative",
  background: theme.palette.mode === "light"
    ? theme.palette.grey[100] : "#0000002e",
  "&:before": {
    position: "absolute",
    content: '""',
    top: "14px",
    left: "-5px",
    borderStyle: "solid",
    background: "transparent",
    borderWidth: "0 10px 10px 0",
    transform: "rotate(-135deg)",
    borderColor: theme.palette.mode === "light"
      ? "transparent #f3f4f6 transparent transparent"
      : "transparent #0000002e transparent transparent",
  },
}));

interface Props {
  chatData: any;
}
const ReplayMessage: FC<Props> = ({ chatData }) => {
  return (
    <ReplayMassageBox>
      <Avatar
        src={chatData.photoUrl}
        sx={{ mr: "15px", width: 35, height: 35 }}
      />
      <Message>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <H4>{chatData.name}</H4>
          <Paragraph>25 min ago</Paragraph>
        </Box>
        <Paragraph mt="10px">{chatData.message}</Paragraph>
      </Message>
    </ReplayMassageBox>
  );
};

export default ReplayMessage;
